import React from "react";
import { Button } from "@thrivetribe/mvf.ui.atoms.button";
import { ButtonArrow } from "@thrivetribe/mvf.assets.icons.button-arrow";
import {
  Card,
  CardActions,
  CardContent,
  CardMedia,
} from "@thrivetribe/mvf.ui.molecules.card";
import "./article-card.scss";

const truncateString = (string: string, length: number) => {
  if (string.length > length) {
    return `${string.substring(0, length)}...`;
  }
  return string;
};

export type ArticleCardProps = {
  className?: string;
  title: string;
  truncateTitle?: boolean;
  description: string;
  imgUrl: string;
  imgTitle: string;
  ctaText?: string | JSX.Element;
  onClick?: () => void;
};

export function ArticleCard({
  className,
  title,
  truncateTitle = true,
  description,
  imgUrl,
  imgTitle,
  ctaText,
  onClick,
}: ArticleCardProps) {
  const CtaElement = (): JSX.Element => {
    if (ctaText === undefined) {
      return (
        <>
          Read more <ButtonArrow />
        </>
      );
    }

    if (typeof ctaText === "string") {
      return (
        <>
          {ctaText} <ButtonArrow />
        </>
      );
    }

    return ctaText;
  };

  return (
    <Card className={`article-card ${className}`} onClick={onClick}>
      <CardMedia imgUrl={imgUrl} imgTitle={imgTitle} />
      <CardContent
        title={truncateTitle ? truncateString(title, 30) : title}
        description={truncateString(description, 150)}
      />
      <CardActions>
        <Button variant="text" onClick={onClick} tabIndex={-1}>
          <CtaElement />
        </Button>
      </CardActions>
    </Card>
  );
}
